export enum UserRole {
  USER = 'USER',
  USER_ADMIN = 'USER_ADMIN',
  LOCATION_MANAGER = 'LOCATION_MANAGER',
  LOCATION_MANAGER_ADMIN = 'LOCATION_MANAGER_ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN'
}